<template>
  <div
    :class="$style.activitiesWidgetContainer"
  >
    <featured-activities-list
      :class="$style.activitiesWidgetList"
      :activities="activities"
      class="grid gap-8"
    />
  </div>
</template>

<script>
import FeaturedActivitiesList from '@/src/server/components/Activities/FeaturedActivitiesList'

export default {
  components: {
    FeaturedActivitiesList,
  },
  data: () => ({
    activities: [],
  }),
  computed: {
    activitiesAmount () {
      return Math.max(1, Math.min(15, this.$route.query.amount || 6))
    },
    managerId () {
      return this.$route.query.manager
    },
  },
  async created () {
    this.activities = await this.$activitiesService.fetchFeaturedActivities(this.managerId, this.activitiesAmount)
  },
}
</script>

<style lang="scss" module>
.activities-widget {
  $breakpoint: 54rem;

  &__container {
    @apply w-full;
  }

  &__list {
    grid-template-columns: 1fr;

    @media (min-width: $breakpoint) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/server/components/Activities/Widgets/FeaturedActivities.vue